module.exports = __webpack_public_path__ + "img/night_ezn.dbd470bd.gif";